import React, { Component } from 'react';
import Cabecera from "./cabecera";
import Footer from "./footer2";
import Body from "./bodyCodigo";

class Cod extends Component {
  render() {
    return (
        <div className="container">
        <Cabecera />
        <Body />
        <Footer />
        </div>
    );
  }
}

export default Cod;


// WEBPACK FOOTER //
// ./src/components/codigo.js